<template>
<div>
    <section style="height: 100vh;display: flex;justify-content: center;">
        <!-- Payment Modal -->
        <div v-if="!isLoading" class="modal animated fadeIn show oppay" ref="paymentModal" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered ">

                <button v-if="componentId != 'Status' " name="closeModal" type="button" id="close" ref="close" class="close" data-dismiss="modal" @click.prevent="closeIframe"></button>

                <div class="modal-content" :style="{ background : modalBackground }" ref="modalContent">
                    <!-- Payment Details -->
                    <div class="row mx-0">
                        <div class="col-12 px-0">
                            <div class="details">
                                <!-- <div class="logo"></div> -->
                                <div class="logo hacked-logo" :style="{ 'background': `url(${logoUrl}) !important`}"></div>
                                
                                <div class="titles">
                                    <div class="email" v-text="email"></div>
                                    <div class="amount" >{{ amount }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- /Payment Details -->

                    <!-- Navigation-->
                    <div class="row mx-0">
                        <div class="col-12 px-0">
                            <nav ref="pay-navs" id="pay-navs" class="text-center">
                                <ul class="m-0 nav-hack" :style="paymentChannels && paymentChannels.length > 4 ? '{ flex-wrap: wrap }' : ''">
                                    <li class="app-text-color fg-1" :class="(componentId == 'CardPayment' || componentId == 'OTP' || componentId == 'Pin')? 'active' : '' ">
                                        <a @click="changeComponent('CardPayment')" :style="{cursor:  componentId == 'Status' ?  'not-allowed' : '', background : (isCardActive) ? activeOption : optionsList }" >
                                            <i class="icon-card"></i>
                                            <span :class="componentId == 'Status' ? 'disabled' : ''">Pay with Card</span>
                                        </a>
                                    </li>

                                    <li v-for="(item, key) in paymentChannels" :key="item.label" class="app-text-color fg-1 mb-1" :class="componentId == item.label ? 'active' : '' ">
                                        <a @click="updateComponent(key)" :style="{cursor: componentId == 'Status' ?  'not-allowed' : '', background : (isTransferActive) ? activeOption : optionsList}" >
                                            <i :class="item.icon"></i>
                                            <span v-text="item.label == 'Transfer' || item.label == 'TRANSFER' ? 'Bank Transfer' : item.label" :class="componentId == 'Status' ? 'disabled' : ''"></span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <!-- /Navigation -->

                    <div class="row mx-0">

                        <div class="col-12">

                            <div class="opt-content card ">
                                <transition name="fade" mode="out-in">
                                    <!-- Retains Data in input boxes-->
                                    <!-- <keep-alive> -->
                                    <component v-if="componentId" :is="componentId" :appColor="appColor" :data="channelDetails" v-bind="channelDetails" />

                                    <div id="app-loader" ref="app-loader" class="text-center my-3" v-else>
                                        <div ref="spinner" class="app-loader__spinner">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <!-- </keep-alive> -->
                                </transition>
                            </div>
                        </div>
                    </div>

                    <div class="footer text-center">
                        <span v-html="providerText"></span>
                        <div v-if="env" style="color:gold;" class="mt-2">You're in Staging environment</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- / Payment Modal -->
    </section>

</div>
</template>

<script>
/* eslint-disable */
// var isIframe = window.parent.location !== window.location,
var win = window.parent;

const Status = () => import('./Status.vue')
import CardPayment from './CardPayment.vue'
import Transfer from './Transfer.vue'
import Paypoint from './Paypoint.vue'
import Pin from './Pin.vue'
import OTP from './Otp.vue'
import axios from 'axios';

export default {
    name: 'popup',
    components: {
        CardPayment,
        Transfer,
        Paypoint,
        Pin,
        OTP,
        Status,

    },
    computed: {
        email() {
            var ctm = this.payload.transaction.customer;
            return ctm.email;
        },
        amount() {
            var trx = this.payload.transaction;
            let amt = trx.amount.toString().split('');
            amt.splice(-2, 0, '.');
            return `₦${amt.join('')}`;
        },
    },
    watch: {
        componentId(newval) {
            if (this.componentId == 'CardPayment' || this.componentId == 'OTP' || this.componentId == 'Pin') {
                this.isCardActive = true;
            }

            if (this.componentId == 'Transfer') {
                this.isTransferActive = true;
            }
        },
        isCardActive(newVal) {
            if (newVal) {
                this.isCardActive = newVal;
                this.isTransferActive = false;
            } else {
                this.isTransferActive = true;
            }
        },
        isTransferActive(newVal) {
            if (newVal) {
                this.isCardActive = false;
                this.isTransferActive = false;
            } else {
                this.isCardActive = true;
            }
        },
        payload(newVal) {
            this.payload = newVal;
            if (!this.$store.state.isFailed)
                this.paymentOptions(newVal)

        },
        channels(newVal) {
            this.channels = newVal;
        },
        isLoading(newVal) {
            this.isLoading = newVal;
        },
        channelDetails(newVal) {
            this.channelDetails = newVal;
        },
        hasLoaded(newVal) {
            this.hasLoaded = newVal;
        },
        /* modalBackground(newVal){
            this.modalBackground = newVal;
            console.log(newVal);
        } */
    },
    created() {

        if (this.componentId == 'CardPayment' || this.componentId == 'OTP' || this.componentId == 'Pin') {
            this.isCardActive = true;
        }

        if (this.isCardActive) {
            this.isTransferActive = false;
        } else {
            this.isTransferActive = true;
        }

        this.isIframe = window.isIframe;

        /* if(newVal){
            this.isCardActive = false;
            this.isTransferActive = false;
        }else{
            this.isCardActive = true;
        } */

        var check = window.location.hostname.split('.');
        if (check[0] == 'staging' || check[1] == 'staging' || check[1] == 'dev') {
            this.env = true;
        }

        var vm = this,
            payload;

        window.addEventListener('message', (event) => {
            if (event.data.path == "newTransaction" && event.data.type == "inline:url") {
                payload = event.data.params
                this.payload = payload
                this.$store.dispatch('payload', payload);
            }
        }, false);

        if (isIframe) {
            this.isIframe = true;
            // Check to see if values are still present
            if (this.$store.state.payload.api_key != "undefined" && this.$store.state.isFailed) {
                let newRef = Date.now() + (Math.floor(Math.random() * 10000)).toString();
                this.payload = this.$store.state.payload;
                this.$store.dispatch('transRef', newRef);
                this.payload.request_ref = newRef;
                this.channels = this.paymentChannels = this.$store.state.options.paymentoptions
                var res = this.$store.state.options;
                this.providerText = res.clientInfo.footer_text;
                this.modalBackground = res.clientInfo.modal_background_color + ' !important';
                this.logoUrl = res.clientInfo.merchant.logo || '';
                
                this.appColor = res.clientInfo.primary_button_color + ' !important';
                this.activeOption = res.clientInfo.payment_option_active_color + ' !important';
                this.optionsList = res.clientInfo.payment_option_color;

                vm.isLoading = false;
                setTimeout(function () {
                    vm.componentId = "CardPayment"
                }, 1000);

            } else if (this.payload.api_key != undefined && !this.$store.state.isFailed) {
                this.paymentOptions(this.payload);
            } else {
                // this.isLoading = false
                // this.$router.push({name:'warning'});
            }
        }

    },
    data() {
        return {
            // componentId: 'CardPayment',
            componentId: '',
            channelDetails: {},
            hasLoaded: false,
            isIframe: false,
            isIframe: '',
            isCardActive: false,
            isTransferActive: false,
            isMTN: false,
            modalBackground: '',
            appColor: '',
            logoUrl: '',
            textColor: '',
            activeOption: '',
            optionsList: '',
            paymentChannels: {},
            isLoading: true,
            channels: {},
            payload: {},
            providerText: '',
            options: {},
            showStatus: false,
            env: false,
        }
    },
    methods: {
        deactivated: function () {
            // remove any data you do not want to keep alive
            // console.log("This is deactivated")
        },
        activated: function () {
            // remove any data you do not want to keep alive
            // console.log("This is activated")
        },
        paymentOptions(data) {
            var vm = this;
            axios.post(this.baseApiUrl + "v1/options", {
                    "data": this.$generateToken(data)
                }, {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }).then(response => {

                    if (response.status === 200) {
                        var res = response.data;
                        window.raw = JSON.stringify(res.data);
                        
                        // console.log(res);
                        // console.log(JSON.stringify(res.data));

                        if (res.code == "00") {
                            this.channels = this.paymentChannels = res.paymentoptions;
                            this.options = res;
                            this.$store.dispatch('options', res);
                            this.$store.dispatch('transRef', res.transRef);
                            this.$store.dispatch('parentTransRef', res.transRef);
                            this.$store.dispatch('client_info', res.data.data.client_info);

                            if (res.provider == "RavePay")
                                this.hasOtp = true;

                            this.providerText = res.clientInfo.footer_text;

                            this.modalBackground = res.clientInfo.modal_background_color + ' !important';
                            this.appColor = res.clientInfo.primary_button_color + ' !important';
                            this.activeOption = res.clientInfo.payment_option_active_color + ' !important';
                            this.optionsList = res.clientInfo.payment_option_color;
                            this.logoUrl = res.clientInfo.merchant.logo || '';
                            

                            setTimeout(function () {
                                vm.isLoading = false;
                                vm.componentId = "CardPayment"
                            }, 500);
                        } else if (res.code == "99") {
                            if (res.data)
                                window.raw = JSON.stringify(res.data);

                            window.failedFromStart = true;
                            vm.$router.push('warning');

                            vm.changeComponent('Status', {
                                type: 'warning',
                                heading: "Data Validation Error",
                                message: res.message,
                            })
                        } else if (res.code == "04") {
                            window.failedFromStart = true;
                            if (res && res.data) {
                                window.raw = JSON.stringify(res.data);
                            }
                            vm.$router.push('warning');
                        } else if (res.code == "01") {
                            window.failedFromStart = true;
                            vm.$router.push('warning');
                        } else if (res.code == null) {
                            window.failedFromStart = true;
                            window.failedFromStartMessage = "An error occured from the main server, please try again or contact the webmaster hussien@onepipe.io."
                            vm.$router.push('warning');
                        } else {
                            window.failedFromStart = true;
                            window.raw = JSON.stringify(res.data);
                            vm.$router.push('warning');
                        }

                    } else {
                        if (res.data)
                            window.localStorage.raw = JSON.stringify(res.data);
                        vm.$router.push('warning');
                    }
                })
                .catch(error => {
                    window.failedFromStart = true;
                    window.failedFromStartMessage = error
                    window.raw = JSON.stringify(error);
                    vm.$router.push('warning');
                });
        },
        changeComponent(name, data = null) {
            if (this.componentId == 'Status')
                return;
            this.componentId = name;
            if (data != null) {
                this.channelDetails = data;
            }
        },
        updateComponent(key) {
            if (this.componentId == 'Status')
                return;
            this.channelDetails = this.channels[key]

            this.$store.dispatch('paymentMethod', this.channelDetails.option)
            this.componentId = this.channelDetails.label;
        },
        closeIframe() {
            this.isLoading = true;
            this.hasLoaded = false;
            this.componentId = 'CardPayment';
            this.$store.replaceState({
                paymentMethod: 'CARD',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                hasOtp: false,
                isFailed: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });

            this.$store.dispatch('isFailed', false);

            if (isIframe) {
                window.parent.postMessage('close', '*');

                if (this.$route.name != 'popup')
                    this.$router.push('/popup').catch(err => {});

                this.componentId = 'CardPayment';
            } else
                console.warn("Oops.. OnePipejs can only close when triggered from an iframe");

        },
        continueToMerchant(data) {
            var raw = JSON.parse(window.raw)
            delete raw.data.client_info;
            delete raw.data.paymentoptions;

            var dataResponse = data.data || raw.data

            var response = {
                status: data.status,
                message: data.message,
                data: dataResponse,
                amount: this.$store.state.payload.transaction.amount || 0,
                paymentmethod: this.$store.state.paymentMethod || null,
                reference: this.$store.state.transRef || null,
                optionsTransRef: this.$store.state.options.optionsTransRef || null,
            }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef
            this.$store.replaceState({
                paymentMethod: 'CARD',
                payload: {},
                options: {},
                api_key: null,
                hasPaid: false,
                hasOtp: false,
                isFailed: false,
                isLoading: true,
                channels: {},
                parentTransRef: '',
                transRef: '',
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: ''
                }
            });

            window.parent.postMessage(JSON.stringify(response), '*');
            if (this.$route.name != 'popup')
                this.$router.push('/popup').catch(err => {});
            this.componentId = 'CardPayment';
        },
    },

};
</script>

<style>


.text-black {
    color: #060100 !important;
}

.hacked-logo {
    width: 35px !important;
    height: 35px !important;
    background-repeat: no-repeat !important;
    /* border: solid #ffffff 2px; */
}

.fg-1 {
    flex-grow: 1;
}

.fg-2 {
    flex-grow: 2;
}

.nav-hack {
    display: flex;
    align-items: justify;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-content: space-evenly;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .7s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}

.disabled,
a.disabled {
    text-decoration: none;
    cursor: not-allowed;
}
</style>
